/* global axios */
import ApiClient from './ApiClient';

class TalkviaFunnelsAPI extends ApiClient {
  constructor() {
    super('talkvia_funnels', { accountScoped: true });
  }

  get(params = {}) {
    return axios.get(this.url, { params });
  }

  create(data) {
    return axios.post(this.url, { talkvia_funnel: data });
  }

  update(id, data) {
    return axios.patch(`${this.url}/${id}`, { talkvia_funnel: data });
  }

  // Somente leitura: contagens reais por nó no período.
  metrics(id, params = {}) {
    return axios.get(`${this.url}/${id}/metrics`, { params });
  }

  // Teste explícito do nó Requisição HTTP (somente administradores).
  testHttpRequest(id, { request, samples = {}, conversationDisplayId = '' }) {
    return axios.post(`${this.url}/${id}/test_http_request`, {
      request_settings: request,
      sample_settings: samples,
      conversation_display_id: conversationDisplayId || undefined,
    });
  }
}

export default new TalkviaFunnelsAPI();
